<template lang="pug">
Transition(name='modal-fade')
    BaseModal.program-modal(
        v-if="isOpen"
        @backdropClick="$emit('close')"
    )
        template(v-slot:header)
            .header-title {{ headerText }}
            IconClose(class="icon-close" @click="$emit('close')")
        template(v-slot:body)
            template(v-if="!activePathway")
                .pathways-container(v-if="pathways")
                    .list-item(v-for="pathway in pathways" @click="onPathwayClick(pathway)")
                        p.program-name {{ pathway.name }}
                        IconChevron.icon-chevron
            .program-of-study(v-else)
                .top
                    .go-back(@click="activePathway = null")
                        IconChevron.icon-chevron(direction="left")
                        p.go-back-text Back to programs
                    DownloadLink(@click="downloadProgram")
                .middle
                    CtePathwayPreview.preview(:ctePathway="activePathway")
                .bottom
                    div.button(role="button" @click="onChooseProgramClick") Choose this Program of Study
</template>

<script>
import BaseModal from '@/components/BaseModal';
import IconClose from '@/components/IconClose';
import IconDownload from '@/components/IconDownload';
import IconChevron from '@/components/IconChevron';
import DownloadLink from '@/components/DownloadLink';
import CtePathwayPreview from '@/components/CtePathwayPreview';
import downloadCTEPathway from '@/lib/downloadCTEPathway';

export default {
  name       : 'program-of-study-modal',
  components : {
    BaseModal,
    IconClose,
    IconDownload,
    IconChevron,
    DownloadLink,
    CtePathwayPreview
  },
  props : {
    isOpen   : Boolean,
    sector   : Object,
    pathways : Array
  },

  data() {
    return {
      activePathway : null,
    };
  },

  computed : {
    headerText() {
      if ( !this.sector ) return '';

      if ( this.activePathway ) {
        return `${this.sector.name} Program of Study: ${this.activePathway.name}`;
      }

      return `${this.sector.name} Programs of Study`;
    },
  },

  watch : {
    // Reset activePathway whenever the modal closes
    isOpen : {
      immediate : true,
      handler( newIsOpen ) {
        if ( !newIsOpen ) {
          this.activePathway = null;
        }
      }
    }
  },

  methods : {
    onPathwayClick( pathway ) {
      this.activePathway = pathway;
    },

    onChooseProgramClick() {
      this.$emit( 'chooseProgram', this.activePathway );
    },

    downloadProgram() {
      downloadCTEPathway( this.activePathway );
    }
  }
};
</script>

<style lang="scss" scoped>
// Animates such that the backdrop fades in and the modal content slides in from the bottom
.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;

    &::v-deep .modal {
        transform: translateY(50vh);
    }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.3s ease;

    &::v-deep .modal {
        transition: transform 0.3s ease;
    }
}

.program-modal {
    z-index: 1;
    max-height: 100vh;

    &::v-deep .modal {
        max-height: 90vh;
        width: 90%;
        min-height: 400px;
        display: flex;
        flex-direction: column;

        @include sm {
            width: 600px;
        }

        .modal-header {
            padding: 20px;
            padding-bottom: 15px;

            .header-title {
                width: 70%;
                font-size: 21px;
            }

            .icon-close {
                position: absolute;
                top: 15px;
                right: 15px;
                color: white;
            }
        }

        .modal-body {
            padding: 20px;
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: auto;

            .list-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;

                &:not(:last-child) {
                    margin-bottom: 10px;
                }

                .program-name {
                    font-weight: 500;
                    font-size: 18px;
                }

                .icon-chevron {
                    color: #4F4F4F;
                    width: 10px;
                }
            }

            .program-of-study {
                flex: 1;
                display: flex;
                flex-direction: column;

                .top {
                    display: flex;
                    justify-content: space-between;

                    .go-back {
                        cursor: pointer;
                        display: flex;
                        align-items: center;

                        .go-back-text {
                            font-size: 18px;
                            margin-left: 20px;
                        }

                        .icon-chevron {
                            width: 8px;
                        }
                    }

                    .download-button {
                        display: flex;
                        align-items: center;
                        color: #1C4587;
                        cursor: pointer;

                        .icon-download {
                            width: 14px;
                            margin-right: 10px;
                        }

                        .button-text {
                            font-weight: 500;
                        }
                    }
                }

                .middle {
                    flex: 1 1 auto;
                    margin: 20px 0;
                    overflow: auto;

                    .preview {
                        max-width: 100%;
                        height: auto;
                    }
                }

                .bottom {
                    margin-top: auto;
                }
            }
        }
    }
}
</style>
